import { useIsAuthenticated, useMsal, useAccount } from '@azure/msal-react';
import { AccountInfo } from '@azure/msal-browser';
import { loginRequest } from '../config/authConfig';
import { UseAuthenticationReturn } from '../types/hooks';

export const useAuthentication = (): UseAuthenticationReturn => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const account = useAccount(accounts[0] || {}) as AccountInfo | null;

  const signIn = async (): Promise<void> => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Sign in error:', error);
      throw error;
    }
  };

  const signOut = async (): Promise<void> => {
    try {
      await instance.logoutRedirect({
        postLogoutRedirectUri: "/"
      });
    } catch (error) {
      console.error('Sign out error:', error);
      throw error;
    }
  };

  const getAccessToken = async (scopes: string[] = loginRequest.scopes): Promise<string | null> => {
    if (!account) return null;

    try {
      const response = await instance.acquireTokenSilent({
        scopes,
        account
      });
      return response.accessToken;
    } catch (error) {
      console.error('Token acquisition error:', error);
      return null;
    }
  };

  return {
    isAuthenticated,
    user: null, // Will be populated by AuthContext
    loading: false, // Will be managed by AuthContext
    error: null, // Will be managed by AuthContext
    login: signIn,
    logout: signOut,
    refreshAuth: async () => {
      // Refresh authentication state
      try {
        await getAccessToken();
      } catch (error) {
        console.error('Auth refresh error:', error);
      }
    }
  };
};
